<div class="email-composer-container">
  <ngx-composer-header [activeView]="activeView" (viewChange)="setActiveView($event)"></ngx-composer-header>

  <!-- Content Area -->
  <div class="composer-content">
    <!-- Templates List View -->
    <ngx-template-list *ngIf="activeView === 'templates'" (editTemplate)="onTemplateEdit($event)" (createTemplate)="onTemplateCreate()"></ngx-template-list>

    <!-- Template Editor View (Full Page) -->
    <ngx-template-editor *ngIf="activeView === 'template-editor'" [templateId]="editingTemplateId" (backToList)="onBackToTemplates()"></ngx-template-editor>

    <!-- Component Manager View -->
    <ngx-component-manager *ngIf="activeView === 'components'" (editComponent)="onComponentEdit($event)" (createComponent)="onComponentCreate()"></ngx-component-manager>

    <!-- Component Editor View (Full Page) -->
    <ngx-component-editor
      *ngIf="activeView === 'component-editor'"
      [componentId]="editingComponentId"
      (close)="onBackToComponents()"
      (saved)="onComponentSaved($event)"
    ></ngx-component-editor>

    <!-- Theme Manager View -->
    <ngx-theme-manager *ngIf="activeView === 'themes'" (editTheme)="onThemeEdit($event)" (createTheme)="onThemeCreate()"> </ngx-theme-manager>

    <!-- Theme Editor View (Full Page) -->
    <ngx-theme-editor *ngIf="activeView === 'theme-editor'" [themeId]="editingThemeId" (close)="onBackToThemes()" (saved)="onThemeSaved($event)"> </ngx-theme-editor>

    <!-- Actions Manager View -->
    <ngx-actions-manager *ngIf="activeView === 'actions'" (editAction)="onActionEdit($event)"></ngx-actions-manager>

    <!-- Action Editor View (Full Page) -->
    <ngx-action-editor *ngIf="activeView === 'action-editor'" [actionId]="editingActionId" (close)="onBackToActions()" (saved)="onActionSaved($event)"></ngx-action-editor>
  </div>
</div>
